import { useQuery } from '@tanstack/react-query'
import { baseURL, headers, STALE_TIME } from '@/v2/constants/requests'

export const usePerformanceMetrics = (
  startDate,
  endDate,
  { utmSource = '', utmMedium = '', utmCampaign = '' } = {}
) => {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: [
      'performanceMetrics',
      startDate,
      endDate,
      utmSource,
      utmMedium,
      utmCampaign,
    ],
    queryFn: async () => {
      const params = new URLSearchParams({
        start_date: startDate,
        end_date: endDate,
        page: 1,
        per_page: 10,
      })
      if (utmSource) params.append('utm_source', utmSource)
      if (utmMedium) params.append('utm_medium', utmMedium)
      if (utmCampaign) params.append('utm_campaign', utmCampaign)

      const res = await fetch(
        `${baseURL}/v2/rest/reports/performance_metrics?${params}`,
        {
          method: 'GET',
          headers,
        }
      )

      if (!res.ok) {
        if (res.status === 403) {
          throw new Error('Admin access required to view performance metrics')
        }
        throw new Error('Failed to fetch performance metrics')
      }

      const result = await res.json()
      return result
    },
    staleTime: STALE_TIME,
    cacheTime: STALE_TIME * 2,
    enabled: !!startDate && !!endDate,
    retry: 1, // Retry once on failure
  })

  return {
    metrics: data,
    isLoading,
    isError,
    error,
    refetch,
  }
}
